import { render, staticRenderFns } from "./student-list.component.vue?vue&type=template&id=08eee54d&scoped=true"
import script from "./student-list.component.vue?vue&type=script&lang=js"
export * from "./student-list.component.vue?vue&type=script&lang=js"
import style0 from "./student-list.component.vue?vue&type=style&index=0&id=08eee54d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eee54d",
  null
  
)

export default component.exports